module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_pref",
    attrs: {
      "epub:type": "preface"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIX",
      "title": "XIX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Preface")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("his second edition introduces more common types of geophysical logs and subsurface maps that can be generated from basic well data. This book aims to provide you with an overview of the many different types of common well logs and applied subsurface maps, while demonstrating that you can successfully interpret well logs and generate your own maps with a little practice. Three new chapters have been added that cover a variety of current topics (including unconventional resources, source rocks, geothermal maps, spectral gamma ray logs, and fault seal analysis). As in the first edition, additional applied exercises at the end of each chapter introduce different types of well logs and lithologies in an incremental manner.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Subsurface mapping is a way to represent and visualize many different types of geologic information, whether directly measured or indirectly estimated from wells, seismic, or other sources. All subsurface map types can be useful, but the key is to know what you are investigating and what map types are most appropriate. For example, to evaluate facies changes, a structure contour map may not be as helpful as a paleogeographic map or a simple cross section. Most subsurface maps today are digitally generated, manipulated, and interpreted by geologists using advanced computer contouring algorithms and software packages. With the rise in “big data” and an ever-larger array of data sources, the inherent uncertainty within subsurface maps has not been removed. In some ways, the dependency on digital data and default software parameters can give a false sense of accuracy and a general underestimation of risk. It is still fundamentally important to understand what different maps represent in the subsurface. Experience is crucial, both with the software and geological. New software programs are capable of generating very eye-catching maps and cross sections, but an experienced geologist or engineer with solid fundamentals can produce superior maps when integrating observations and models based on past experiences. Subsurface mapping and interpreting geophysical logs are nonunique arts. There can be many plausible solutions, but none of them may adequately capture the actual subsurface complexity. Keep in mind that a map is never really complete. New data will always alter it, and possibly will also alter the inferred geological model. Good luck with the exercises, and keep an open mind.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For the answer key, please contact the author at "), _c('a', {
    staticClass: "mailto",
    attrs: {
      "href": "mailto:jevenick@hotmail.com."
    }
  }, [_vm._v("jevenick@hotmail.com.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0